import {
  toDelayMillis3fd263ql63uu2 as toDelayMillis,
  get_delaynv5kl66dta33 as get_delay,
  DelayWithTimeoutDiagnostics19ibxwhhgbjz0 as DelayWithTimeoutDiagnostics,
} from './Delay.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine } from './internal/Scopes.mjs';
import { Key_instancep4kcxau6t0nv as Key_instance } from './CoroutineName.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { disposeOnCompletion1zvxmj809ax5i as disposeOnCompletion } from './Job.mjs';
import { startUndispatchedOrReturnIgnoreTimeout3dcuyudwff859 as startUndispatchedOrReturnIgnoreTimeout } from './intrinsics/Undispatched.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1n9qg6fb0b5i8 as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substring3saq8ornu0luv as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *withTimeoutOrNull(timeout, block, $completion) {
  return yield* withTimeoutOrNull_0(toDelayMillis(timeout), block, $completion);
}
var TimeoutCancellationExceptionClass;
function TimeoutCancellationException() {
  if (TimeoutCancellationExceptionClass === VOID) {
    class $ extends CancellationException() {
      constructor(message, coroutine) {
        return new.target.new_kotlinx_coroutines_TimeoutCancellationException_5ymn8b_k$(message, coroutine);
      }
      static new_kotlinx_coroutines_TimeoutCancellationException_5ymn8b_k$(message, coroutine) {
        var $this = this.new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$(message);
        captureStack($this, $this.$throwableCtor_5);
        $this.coroutine_1 = coroutine;
        return $this;
      }
    }
    initMetadataForClass($, 'TimeoutCancellationException');
    TimeoutCancellationExceptionClass = $;
  }
  return TimeoutCancellationExceptionClass;
}
function *withTimeoutOrNull_0(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    return null;
  var coroutine = {_v: null};
  try {
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var timeoutCoroutine = new (TimeoutCoroutine())(timeMillis, uCont);
      coroutine._v = timeoutCoroutine;
      return setupTimeout(timeoutCoroutine, block);
    };
  } catch ($p) {
    if ($p instanceof TimeoutCancellationException()) {
      var e = $p;
      if (e.coroutine_1 === coroutine._v) {
        return null;
      }
      throw e;
    } else {
      throw $p;
    }
  }
}
var TimeoutCoroutineClass;
function TimeoutCoroutine() {
  if (TimeoutCoroutineClass === VOID) {
    class $ extends ScopeCoroutine() {
      constructor(time, uCont) {
        super(uCont.get_context_h02k06_k$(), uCont);
        this.time_1 = time;
      }
      run_mvkpxh_k$() {
        var delay = get_delay(this.context_1);
        var tmp0_safe_receiver = this.context_1.get_y2st91_k$(Key_instance);
        var name = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
        this.cancelCoroutine_rpko3c_k$(TimeoutCancellationException_0(this.time_1, delay, this, name));
      }
      nameString_4rfuxd_k$() {
        return super.nameString_4rfuxd_k$() + '(timeMillis=' + this.time_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'TimeoutCoroutine', VOID, VOID, [Runnable()], [0]);
    TimeoutCoroutineClass = $;
  }
  return TimeoutCoroutineClass;
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.uCont_1;
  var context = cont.get_context_h02k06_k$();
  disposeOnCompletion(coroutine, get_delay(context).invokeOnTimeout_nj9oyy_k$(coroutine.time_1, coroutine, coroutine.context_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine, coroutineName) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics()) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.timeoutMessage_4970sf_k$(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var baseMessage = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  var tmp_0;
  if (!(coroutineName == null)) {
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(baseMessage) > 0) {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(baseMessage, 0);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$5 = toString(this_0).toLowerCase();
      var tmp0 = charCodeAt(tmp$ret$5, 0);
      // Inline function 'kotlin.text.plus' call
      var other = substring(baseMessage, 1);
      tmp_1 = toString(tmp0) + other;
    } else {
      tmp_1 = baseMessage;
    }
    tmp_0 = 'Coroutine "' + coroutineName + '" ' + tmp_1;
  } else {
    tmp_0 = baseMessage;
  }
  var message = tmp_0;
  return TimeoutCancellationException().new_kotlinx_coroutines_TimeoutCancellationException_5ymn8b_k$(message, coroutine);
}
//region block: exports
export {
  withTimeoutOrNull as withTimeoutOrNull1yc5m6zc7bl9o,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
};
//endregion

//# sourceMappingURL=Timeout.mjs.map
